<!-- <ion-app>
 <ion-router-outlet></ion-router-outlet> 
</ion-app> -->
<ion-app [ngClass]="{ 'ad-type-native': adType === 'google' }" *ngIf="isAppReady && !platform.is('android') ">
  <ion-router-outlet [environmentInjector]="environmentInjector" [ngStyle]="{'height': '100dvh'}"></ion-router-outlet>
</ion-app>
<ion-app [ngClass]="{ 'ad-type-native': adType === 'google' }" *ngIf="isAppReady && platform.is('android')"
  [ngStyle] ="ads.hasShown? {'height': 'calc(100dvh - 71px)'} : {'height': '100dvh'}"
>
  <ion-router-outlet [environmentInjector]="environmentInjector"></ion-router-outlet>
</ion-app>